import { Category } from "../../../Models/Category";
import { Subcategory } from "../../../Models/SubCategory";
import { BaseAPICallsHandler } from "../BaseAPICallsHandler";
import { NetworkUtils } from "../NetworkUtils";
import { ServerConfig } from "../ServerConfig";

export interface CategoriesResponse {
    categories: Category[]
    totalCategories: Number
    pageNumber: Number
    pageSize: Number
}
export interface CategoriesWithSubcategoriesResponse {
    categories: {
        category: Category,
        subcategories: Subcategory[]
    }[],
    totalCategories: Number
    pageNumber: Number
    pageSize: Number
}

export class CategoryAPIHandler {
    
    public static shared = new CategoryAPIHandler()
  
    apiHandler = BaseAPICallsHandler.shared
    serverConfig = ServerConfig.shared
    networkUtils = NetworkUtils.shared

    // dependency injection here
    constructor();
    constructor(apiHandler: BaseAPICallsHandler, serverConfig: ServerConfig, networkUtils: NetworkUtils);
    public constructor(...params: any[]) {
        if(params.length >= 3) {
            this.apiHandler = params[0];
            this.serverConfig = params[1];
            this.networkUtils = params[2];
        }
    };

    public async getAllCategories(pageNumber: Number = 1, pageSize: Number = 20): Promise<CategoriesResponse> {
      
        let queryParams = new URLSearchParams()
        queryParams.append('pageNumber', pageNumber.toString());
        queryParams.append('pageSize', pageSize.toString());

        let url = this.serverConfig.categoriesAPIs.categoriesAPI + `?${queryParams.toString()}`;
        
        try {
            
            let categoriesResponse = await this.apiHandler.makeGetRequest({}, url);
            let categoriesData = categoriesResponse.data.categories as Array<any>;

            let categoriesArray = categoriesData.map((category, index) => {
                return new Category(category);
            })
            let responseToSendBack: CategoriesResponse = {
                categories: categoriesArray,
                pageNumber: categoriesResponse.data.pageNumber,
                pageSize: categoriesResponse.data.pageSize,
                totalCategories: categoriesResponse.data.totalCategories
            }
            return Promise.resolve(responseToSendBack);

        } catch (err) {
            return Promise.reject(err);
        }
    }

    public async getAllCategoriesWithSubcategories(pageNumber: Number = 1, pageSize: Number = 20): Promise<CategoriesWithSubcategoriesResponse> {
      
        let queryParams = new URLSearchParams()
        queryParams.append('pageNumber', pageNumber.toString());
        queryParams.append('pageSize', pageSize.toString());

        let url = this.serverConfig.categoriesAPIs.categoriesWithSubcategoriesAPI + `?${queryParams.toString()}`;
        
        try {
            
            let categoriesResponse = await this.apiHandler.makeGetRequest({}, url);
            let categoriesData = categoriesResponse.data.categories as Array<any>;

            let categoriesArray = categoriesData.map((categoryData, index) => {
                const category = new Category(categoryData);
                const subcategories: Subcategory[] = categoryData.subcategories.map((subcategoryData: any, index: number) => {
                    return new Subcategory(subcategoryData);
                })
                return {
                    category,
                    subcategories
                }
            })

            let responseToSendBack: CategoriesWithSubcategoriesResponse = {
                categories: categoriesArray,
                pageNumber: categoriesResponse.data.pageNumber,
                pageSize: categoriesResponse.data.pageSize,
                totalCategories: categoriesResponse.data.totalCategories
            }
            return Promise.resolve(responseToSendBack);

        } catch (err) {
            return Promise.reject(err);
        }
    }

    public async getCategoryById(Id: String): Promise<Category> {
        let url = this.serverConfig.categoriesAPIs.categoriesAPI + Id;
        
        try {
            
            let categoriesResponse = await this.apiHandler.makeGetRequest({}, url);
            let categoriesData = categoriesResponse.data;
            let category = new Category(categoriesData);
            return Promise.resolve(category);

        } catch (err) {
            return Promise.reject(err);
        }
    }

    public async postNewCategory(categoryData: any): Promise<Category> {
        let url = this.serverConfig.categoriesAPIs.categoriesAPI;
        let adminAuthHeaders = this.networkUtils.addAdminAuthHeaders({});

        try {
            
            let categoriesResponse = await this.apiHandler.makePostRequest(adminAuthHeaders, url, categoryData);
            let categoriesData = categoriesResponse.data;
            let category = new Category(categoriesData);
            return Promise.resolve(category);

        } catch (err) {
            return Promise.reject(err);
        }
    }
    
    public async updateCategoryById(categoryData: any, categoryId: String): Promise<Category> {
        let url = this.serverConfig.categoriesAPIs.categoriesAPI + categoryId;
        let adminAuthHeaders = this.networkUtils.addAdminAuthHeaders({});

        try {
            
            let categoriesResponse = await this.apiHandler.makePatchRequest(adminAuthHeaders, url, categoryData);
            let categoriesData = categoriesResponse.data;
            let category = new Category(categoriesData);
            return Promise.resolve(category);

        } catch (err) {
            return Promise.reject(err);
        }
    }

    public async deleteCategoryById(categoryId: String): Promise<String> {
        let url = this.serverConfig.categoriesAPIs.categoriesAPI + categoryId;
        let adminAuthHeaders = this.networkUtils.addAdminAuthHeaders({});
        
        try {
            await this.apiHandler.makeDeleteRequest(adminAuthHeaders, url, {});
            return Promise.resolve("Deleted successfully");

        } catch (err) {
            return Promise.reject(err);
        }
    }

    public async getCategoryBySlug(categorySlug: String): Promise<Category> {
        let url = this.serverConfig.categoriesAPIs.categoryAPI + categorySlug;
        
        try {
            
            let categoriesResponse = await this.apiHandler.makeGetRequest({}, url);
            let categoriesData = categoriesResponse.data;
            let category = new Category(categoriesData);
            return Promise.resolve(category);

        } catch (err) {
            return Promise.reject(err);
        }
    }
}
